import { ColorScheme } from '@blocksuite/affine/model';
import { createSignalFromObservable } from '@blocksuite/affine-shared/utils';
import type { Signal } from '@preact/signals-core';
import { documentThemes, themeModeOf } from '@streamlain/theme';
import { isThemeName } from '@streamlain/theme/v2';
import { Entity, LiveData } from '@toeverything/infra';

// BlockSuite renders document content, so it follows the document table.
const resolveColorScheme = (theme?: string): ColorScheme =>
  isThemeName(theme) && themeModeOf(documentThemes[theme]) === 'dark'
    ? ColorScheme.Dark
    : ColorScheme.Light;

export class AppTheme extends Entity {
  theme$ = new LiveData<string | undefined>(undefined);

  themeSignal: Signal<ColorScheme>;

  constructor() {
    super();
    const { signal, cleanup } = createSignalFromObservable<ColorScheme>(
      this.theme$.map(theme => resolveColorScheme(theme)),
      ColorScheme.Light
    );
    this.themeSignal = signal;
    this.disposables.push(cleanup);
  }
}
